/**
 * AuthGuard: Centralized helper to inspect token presence and validity
 * before permitting protected teacher API calls.
 */
export const AuthGuard = {
  getValidToken(tokenFromContext) {
    const token = tokenFromContext || localStorage.getItem('llap_access_token') || sessionStorage.getItem('llap_access_token');
    if (!token || token === 'undefined' || token === 'null') {
      return null;
    }
    return token;
  },

  handleUnauthorized(error) {
    if (error && (error.status === 401 || error.message?.includes('401') || error.message?.includes('Unauthorized'))) {
      console.warn('AuthGuard detected session expiration (401). Terminating unauthorized polling.');
      return true;
    }
    return false;
  }
};

export default AuthGuard;